import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {GeneralConst, PaymentInventoryDataEndpoint, XmlEndpoint} from '../../app.constants';
import {PaymentInventoryData} from '../../models/payment-inventory-data';
import {InventoryDataXml} from '../../models/inventory-data-xml';
import {CachedServiceFactory} from '../cached-service-factory';
import {CachedServiceEnum} from '../../models/cached-service.enum';

@Injectable()
export class PaymentInventoryDataService {

  constructor(private http: HttpClient,
              private cachedServiceFactory: CachedServiceFactory) {
  }

  getPaymentInventoryData(requestDto): Observable<any> {
    const url = GeneralConst.API_PREFIX + PaymentInventoryDataEndpoint.PAYMENT_INVENTORY_DATA;
    let param = new HttpParams();

    param = param.append('filters', JSON.stringify(requestDto.filters));
    param = param.append('makandId', requestDto.salandId);

    return this.http.get<any>(url, {params: param});
  }

  addPaymentInventoryData(paymentInventoryData: PaymentInventoryData): Observable<any> {
    const url = GeneralConst.API_PREFIX + PaymentInventoryDataEndpoint.PAYMENT_INVENTORY_DATA;
    const cachedService = this.cachedServiceFactory.getCachedService(CachedServiceEnum.ADD_PAYMENT_INVENTORY_DATA);
    return cachedService.performRequest(this.http.post<any>(url, paymentInventoryData));
  }

  updatePaymentInventoryData(paymentInventoryData: PaymentInventoryData): Observable<any> {
    const url = GeneralConst.API_PREFIX + PaymentInventoryDataEndpoint.PAYMENT_INVENTORY_DATA;
    const cachedService = this.cachedServiceFactory.getCachedService(CachedServiceEnum.UPDATE_PAYMENT_INVENTORY_DATA);
    return cachedService.performRequest(this.http.put<any>(url, paymentInventoryData));
  }

  removePaymentInventoryData(id): Observable<any> {
    const url = GeneralConst.API_PREFIX + PaymentInventoryDataEndpoint.PAYMENT_INVENTORY_DATA_DELETE + id;
    return this.http.delete<any>(url, id);
  }

  downloadExcel(partnerName: string, partnerCode: string, periodName: string, requestDto): Observable<Blob> {
    const url = GeneralConst.API_PREFIX + PaymentInventoryDataEndpoint.PAYMENT_INVENTORY_DATA + '/downloadExcel';
    return this.http.get(url, {
      responseType: 'blob',
      params: PaymentInventoryDataService.createParams(partnerName, partnerCode, periodName, requestDto)
    });
  }

  downloadPdf(partnerName: string, partnerCode: string, periodName: string, requestDto): Observable<Blob> {
    const url = GeneralConst.API_PREFIX + PaymentInventoryDataEndpoint.PAYMENT_INVENTORY_DATA + '/downloadPdf';
    return this.http.get(url, {
      responseType: 'blob',
      params: PaymentInventoryDataService.createParams(partnerName, partnerCode, periodName, requestDto)
    });
  }

  private static createParams(partnerName: string, partnerCode: string, periodName: string, requestDto) {
    let param = new HttpParams();

    param = param.append('partnerName', partnerName.toString());
    param = param.append('partnerCode', partnerCode.toString());
    param = param.append('periodName', periodName.toString());
    param = param.append('filters', JSON.stringify(requestDto.filters));
    param = param.append('makandId', requestDto.salandId);
    param = param.append('sort', JSON.stringify(requestDto.sort));
    return param;
  }

  sendXml(paymentInventoryDataXml: InventoryDataXml): Observable<string> {
    const url = GeneralConst.API_PREFIX + PaymentInventoryDataEndpoint.PAYMENT_INVENTORY_DATA + XmlEndpoint.SEND_XML;
    const data: FormData = new FormData();

    data.append('periodId', paymentInventoryDataXml.periodId.toString());
    data.append('paymentInventoryId', paymentInventoryDataXml.inventoryId.toString());
    data.append('xmlFile', paymentInventoryDataXml.xmlFile);

    //TODO better response entity
    return this.http.post<string>(url, data);
  }
}
